export const OECustomPropertyName = {
    overlayFrame: 'overlay_frame'
};